<template>
  <v-list-tile avatar>
    <v-list-tile-avatar>
      <v-icon class="f2-5em k-orange-linear-text">fab fa-whatsapp</v-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>
        <strong>{{ whatsappTemplate.name }}</strong>
      </v-list-tile-title>
      <v-list-tile-sub-title>
        <v-chip small :color="statusColor" :text-color="statusTextColor" class="ma-0">
          {{ statusLabel }}
        </v-chip>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-spacer></v-spacer>
    <v-list-tile-action>
      <v-menu bottom offset-y @click.native.stop>
        <v-btn slot="activator" color="grey darken-2" small flat fab>
          <v-icon>fas fa-ellipsis-v</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-if="canEdit"
            @click="$emit('edit', whatsappTemplate)"
          >
            <v-list-tile-title>Editar</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="canUpdateStatus"
            @click="$emit('approve', whatsappTemplate)"
          >
            <v-list-tile-title>Aprobar</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="canUpdateStatus"
            @click="$emit('reject', whatsappTemplate)"
          >
            <v-list-tile-title>Rechazar</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$emit('delete', whatsappTemplate)">
            <v-list-tile-title>Eliminar</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
const STATUS_LABELS = {
  PENDING: 'Pendiente',
  APPROVED: 'Aprobada',
  REJECTED: 'Rechazada',
};

const STATUS_COLORS = {
  PENDING: 'orange lighten-4',
  APPROVED: 'green lighten-4',
  REJECTED: 'red lighten-4',
};

const STATUS_TEXT_COLORS = {
  PENDING: 'orange darken-4',
  APPROVED: 'green darken-4',
  REJECTED: 'red darken-4',
};

export default {
  props: {
    whatsappTemplate: {
      type: Object,
      required: true,
    },
  },
  computed: {
    normalizedStatus() {
      return (this.whatsappTemplate.status || '').toUpperCase();
    },
    statusLabel() {
      return STATUS_LABELS[this.normalizedStatus] || this.whatsappTemplate.status || 'Sin estado';
    },
    statusColor() {
      return STATUS_COLORS[this.normalizedStatus] || 'grey lighten-3';
    },
    statusTextColor() {
      return STATUS_TEXT_COLORS[this.normalizedStatus] || 'grey darken-3';
    },
    canEdit() {
      return this.normalizedStatus === 'PENDING'
        && this.$auth.user().permissions.includes('edit_whatsapp_templates');
    },
    canUpdateStatus() {
      return this.normalizedStatus === 'PENDING'
        && this.$auth.user().permissions.includes('update_whatsapp_template_status');
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/WhatsappTemplates/WhatsappTemplateItem.vue